import type {ApiResponseData} from '@frontend/types/AppTypes'
import type {ExecutorStatus} from '@shared/types/Executors'
import {handleSuccessResponse} from 'swayok-react-mdb-ui-kit/helpers/api/ApiRequestErrorHelpers'
import {ApiRequestService} from 'swayok-react-mdb-ui-kit/services/ApiRequestService'
import type {FormSelectOptionsList} from 'swayok-react-mdb-ui-kit/types/Common'
import type {
    MyExecutor,
    MyExecutorBulkActions,
    MyExecutorsFilter,
    MyExecutorStats,
} from './MyExecutorsModuleTypes'

// API собственных исполнителей услуг пользователя.
export const MyExecutorsApi = {

    // Получить список собственных исполнителей услуг.
    async getExecutors(filter: MyExecutorsFilter): Promise<MyExecutorsResponseData> {
        return ApiRequestService
            .get<MyExecutorsResponseData>(`/v1/cabinet/executors/list/${filter}`)
            .then(response => response.data)
    },

    // Получить список исполнителей услуг для формы отправки первого сообщения заказчику услуги.
    // Только для объявлений в категориях типа "Требуется услуга".
    async getMyPublishedExecutorsAsOptions(): Promise<MyPublishedExecutorsAsOptionsResponseData['options']> {
        return ApiRequestService
            .get<MyPublishedExecutorsAsOptionsResponseData>('/v1/cabinet/executors/published/options')
            .then(response => response.data.options)
    },

    // Получить количество собственных исполнителей услуг по каждому фильтру и выручку.
    async getStats(): Promise<MyExecutorStats> {
        return ApiRequestService
            .get<MyExecutorsStatsResponseData>('/v1/cabinet/executors/stats')
            .then(response => response.data.stats)
    },

    // Опубликовать исполнителя услуг.
    async publish(
        this: void,
        id: number,
        ignoreMessage: boolean = false
    ): Promise<ExecutorStatus> {
        return ApiRequestService
            .post<MyExecutorPublishingResponseData>(`/v1/cabinet/executor/${id}/publish`)
            .then(response => {
                if (!ignoreMessage) {
                    handleSuccessResponse(response)
                }
                return response.data.status
            })
    },

    // Удалить исполнителя услуг.
    async delete(id: number): Promise<boolean> {
        return ApiRequestService
            .delete<ApiResponseData>(`/v1/cabinet/executor/${id}`)
            .then(response => {
                handleSuccessResponse(response)
                return response.data.result
            })
    },

    // Снятие исполнителя услуг с публикации.
    async close(id: number): Promise<boolean> {
        return ApiRequestService
            .post<ApiResponseData>(`/v1/cabinet/executor/${id}/close`)
            .then(response => {
                handleSuccessResponse(response)
                return response.data.result
            })
    },

    // Временное снятие исполнителя услуг с публикации.
    async pause(id: number): Promise<boolean> {
        return ApiRequestService
            .post<ApiResponseData>(`/v1/cabinet/executor/${id}/pause`)
            .then(response => {
                handleSuccessResponse(response)
                return response.data.result
            })
    },
}

interface MyExecutorsResponseData extends ApiResponseData {
    records: MyExecutor[]
    count: number
    stats: MyExecutorStats
    bulkActions: MyExecutorBulkActions
}

interface MyExecutorsStatsResponseData extends ApiResponseData {
    stats: MyExecutorStats
}

interface MyExecutorPublishingResponseData extends ApiResponseData {
    status: ExecutorStatus
}

export interface MyPublishedExecutorsAsOptionsResponseData extends ApiResponseData {
    options: FormSelectOptionsList<number, {
        categoryName?: string
    }>
}
